import React from "react";
import { Container } from "react-bootstrap";
import Link from "components/link";
import {
  productsCategories,
  categoriesContent, categoryContainer, content, prodImg,
  isActive, title, notActive, isSelected
} from "./style.mod.scss";
import getImagePath from "helpers/get-image-path";
import { Swiper, SwiperSlide } from "swiper/react";
import { useMediaQuery } from "react-responsive";
import FiltersRoundedImages from "../collection-filter-slider/rounded-images";

const ProductsCategories = ({ collectionSettings, collHandle }) => {
  const collectionUrl = (handle) => `/collections/${handle}`;
  const isMobile = useMediaQuery({ query: "(max-width: 1023.98px)" });

  var settings = {
    spaceBetween: 25,
    slidesPerView: 3.1,
    pagination: { clickable: true },
    navigation: { clickable: true },
    breakpoints: {
      767: {
        slidesPerView: 3,
        spaceBetween: 10,
        pagination: false,
      },
      992: {
        slidesPerView: 4.4,
        spaceBetween: 15,
      },
      1025: {
        spaceBetween: 20,
        slidesPerView: 5.3,
      },
      1270: {
        spaceBetween: 25,
        slidesPerView: 5.3,
      }
    },
  };

  const FiltersWithDiscounts = ({ collectionSettings }) => {
    const showFilter = collectionSettings?.filtersWithDiscounts?.filter((h) => h?.collectionRef?.handle == collHandle);
    if (showFilter?.length === 0 && collHandle !== "alles_2024") return<></>;

    return (
      <div className={productsCategories}>
        <Container>
          <div className={content}>
            <h1 className={title}>{collectionSettings?.title}</h1>
            <div className={categoriesContent}>
              {
                collectionSettings?.filtersWithDiscounts?.map((thisColl, index) => (
                  <Link
                    key={`${collHandle}-${index}`}
                    to={collectionUrl(thisColl?.collectionRef?.handle)}
                  >
                    <button className={collHandle === thisColl?.collectionRef?.handle ? isSelected : notActive} >
                      {thisColl?.title}
                    </button>
                  </Link>
                ))
              }
            </div>
          </div>
        </Container>
        <hr />
      </div>
    );
  };


  const FiltersWithImages = ({ collectionSettings }) => {

    return (
      <div className={productsCategories} id="product-categories">
        <Container>
          {isMobile ?
            <div className={content}>
              <Swiper {...settings}>
                {collectionSettings?.collectionItem?.map((thisColl, index) => (
                  <SwiperSlide key={`mobile-${index}`}>
                    <div className={categoryContainer} key={`${collHandle}-${index}`}>
                      <Link

                        to={collectionUrl(thisColl?.handle?.path)}
                      >
                        <div className={prodImg}>
                          <img src={getImagePath(thisColl?.image)} alt={thisColl?.image?.alt} />
                        </div>
                        <p className={collHandle === thisColl?.handle?.path ? isActive : ""}>
                          {thisColl?.title}
                        </p>
                      </Link>
                    </div>
                  </SwiperSlide>
                ))}

              </Swiper>
            </div> :
            <div className={content}>
              <div className={categoriesContent}>
                {
                  collectionSettings?.collectionItem?.map((thisColl, index) => (
                    <div className={categoryContainer} key={`${collHandle}-${index}`}>
                      <Link

                        to={collectionUrl(thisColl?.handle?.path)}
                      >
                        <div className={prodImg}>
                          <img src={getImagePath(thisColl?.image)} alt={thisColl?.image?.alt} />
                        </div>
                        <p className={collHandle === thisColl?.handle?.path ? isActive : ""}>
                          {thisColl?.title}
                        </p>
                      </Link>
                    </div>
                  ))
                }
              </div>
            </div>}

        </Container>
      </div>
    );

  };

  return (
    <>
      {collectionSettings?.discountFilters &&
        <FiltersWithDiscounts collectionSettings={collectionSettings} />}
      {collectionSettings?.collectionFilter ?
        <FiltersWithImages collectionSettings={collectionSettings} /> : <FiltersRoundedImages data={collectionSettings} />}
    </>

  );
};

export default ProductsCategories;
